import { selector as parseSelector } from 'vega-event-selector';
import { X, Y } from '../../channel';
import { BRUSH as INTERVAL_BRUSH } from './interval';
import scalesCompiler, { domain } from './scales';
var ANCHOR = '_translate_anchor';
var DELTA = '_translate_delta';
var translate = {
  defined: function defined(selCmpt) {
    return selCmpt.type === 'interval' && selCmpt.translate;
  },
  signals: function signals(model, selCmpt, _signals) {
    var name = selCmpt.name;
    var hasScales = scalesCompiler.defined(selCmpt);
    var anchor = name + ANCHOR;
    var _selCmpt$project$hasC = selCmpt.project.hasChannel,
        x = _selCmpt$project$hasC.x,
        y = _selCmpt$project$hasC.y;
    var events = parseSelector(selCmpt.translate, 'scope');

    if (!hasScales) {
      events = events.map(function (e) {
        return e.between[0].markname = name + INTERVAL_BRUSH, e;
      });
    }

    _signals.push({
      name: anchor,
      value: {},
      on: [{
        events: events.map(function (e) {
          return e.between[0];
        }),
        update: '{x: x(unit), y: y(unit)' + (x !== undefined ? ", extent_x: ".concat(hasScales ? domain(model, X) : "slice(".concat(x.signals.visual, ")")) : '') + (y !== undefined ? ", extent_y: ".concat(hasScales ? domain(model, Y) : "slice(".concat(y.signals.visual, ")")) : '') + '}'
      }]
    }, {
      name: name + DELTA,
      value: {},
      on: [{
        events: events,
        update: "{x: ".concat(anchor, ".x - x(unit), y: ").concat(anchor, ".y - y(unit)}")
      }]
    });

    if (x !== undefined) {
      onDelta(model, selCmpt, x, 'width', _signals);
    }

    if (y !== undefined) {
      onDelta(model, selCmpt, y, 'height', _signals);
    }

    return _signals;
  }
};
export default translate;

function onDelta(model, selCmpt, proj, size, signals) {
  var _a, _b;

  var name = selCmpt.name;
  var anchor = name + ANCHOR;
  var delta = name + DELTA;
  var channel = proj.channel;
  var hasScales = scalesCompiler.defined(selCmpt);
  var signal = signals.filter(function (s) {
    return s.name === proj.signals[hasScales ? 'data' : 'visual'];
  })[0];
  var sizeSg = model.getSizeSignalRef(size).signal;
  var scaleCmpt = model.getScaleComponent(channel);
  var scaleType = scaleCmpt.get('type');
  var reversed = scaleCmpt.get('reverse'); // scale parsing sets this flag for fieldDef.sort

  var sign = !hasScales ? '' : channel === X ? reversed ? '' : '-' : reversed ? '-' : '';
  var extent = "".concat(anchor, ".extent_").concat(channel);
  var offset = "".concat(sign).concat(delta, ".").concat(channel, " / ").concat(hasScales ? "".concat(sizeSg) : "span(".concat(extent, ")"));
  var panFn = !hasScales ? 'panLinear' : scaleType === 'log' ? 'panLog' : scaleType === 'symlog' ? 'panSymlog' : scaleType === 'pow' ? 'panPow' : 'panLinear';
  var arg = !hasScales ? '' : scaleType === 'pow' ? ", ".concat((_a = scaleCmpt.get('exponent')) !== null && _a !== void 0 ? _a : 1) : scaleType === 'symlog' ? ", ".concat((_b = scaleCmpt.get('constant')) !== null && _b !== void 0 ? _b : 1) : '';
  var update = "".concat(panFn, "(").concat(extent, ", ").concat(offset).concat(arg, ")");
  signal.on.push({
    events: {
      signal: delta
    },
    update: hasScales ? update : "clampRange(".concat(update, ", 0, ").concat(sizeSg, ")")
  });
}